module.exports = __webpack_public_path__ + "img/header-engagementRingsHeart@2x.3489cb4.jpg";